import React from 'react';
import { useParams } from 'react-router-dom';

import { useAssignmentResults, useAssignment } from '../../hooks';
import AssignmentResultsTable from '../../components/AssignmentResultsTable';

const AssignmentResultPage = () => {
  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();
  const { assignment } = useAssignment({ courseId, assignmentId });

  const { results, students, onFilterData, loading, onGetXlsxData, onToggleShowOnlyStudentsWithoutAnswer, showOnlyStudentsWithoutAnswer } =
    useAssignmentResults({
      courseId,
      assignmentId,
    });

  return (
    <AssignmentResultsTable
      courseId={courseId}
      results={results}
      students={students}
      loading={loading}
      assignment={assignment}
      onlyListStudentsWithoutAnswers={showOnlyStudentsWithoutAnswer}
      onFilterResults={onFilterData}
      onToggleOnlyListStudentsWithoutAnswers={onToggleShowOnlyStudentsWithoutAnswer}
      onGetXlsxData={onGetXlsxData}
    />
  );
};

export default AssignmentResultPage;
